// extracted by mini-css-extract-plugin
export default {"me":"About_me__svd8b","about":"About_about__mWc3O","in":"About_in__QuAft"};